import { recipeApp, type OsRecipe } from '../os-recipes.js';

const NOTION = recipeApp('notion.id');

/** notion: its app recipes as data (Mac recipes R3). Every entry ships held until its drill lifts it.
 *  Notion is Electron: chords, its native menu bar and deep links only, never an AX walk. The research
 *  rows not here are on the R3 review lists. */
export const RECIPES: readonly OsRecipe[] = [
  {
    id: 'notion.search', app: NOTION, status: 'held', opens: true,
    title: 'Search Notion',
    description: 'Search Notion ("search notion for q3 roadmap").',
    params: { query: { kind: 'literal', description: 'The exact words to search for', cut: 'query' } },
    steps: [{ op: 'open_url', template: 'notion://www.notion.so/nativetab/search?searchQuery={query}' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', cues: ['search', 'find', 'look'],
    reply: 'Searching Notion for {query}.',
  },
  {
    id: 'notion.quick_find', app: NOTION, status: 'held', opens: true,
    title: "Open Notion's search box",
    description: 'Open Notion\'s search box ("open search in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+p' }],
    tier: 'reversible', cues: ['search', 'quick find', 'find', 'search box'],
    reply: "Notion's search is open.",
  },
  {
    id: 'notion.go_to_page', app: NOTION, status: 'held', opens: true,
    title: 'Go to a Notion page by name',
    description: 'Go to a Notion page by name ("go to the Q3 roadmap in notion").',
    params: { name: { kind: 'span', description: "The page's name in their words" } },
    steps: [{ op: 'activate' }, { op: 'focus_mark' }, { op: 'key', chord: 'cmd+p' }, { op: 'focus_moved', timeoutMs: 800, labelIn: ['search'] }, { op: 'type', param: 'name' }, { op: 'settle', ms: 400 }, { op: 'key', chord: 'return' }, { op: 'settle', ms: 150 }, { op: 'verify_title', param: 'name', timeoutMs: 1500 }],
    tier: 'reversible', verify: 'title', cues: ['go', 'open', 'jump', 'take', 'show', 'pull', 'bring', 'kholo', 'page kholo'],
    reply: 'Opened {label} in Notion.',
  },
  {
    id: 'notion.parent_page', app: NOTION, status: 'held', opens: true,
    title: 'Go up to the parent Notion page',
    description: 'Go up to the parent Notion page ("go up a level").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+shift+u' }],
    tier: 'reversible', cues: ['parent', 'up', 'above', 'up a level', 'parent page', 'page above this one', 'up one level', 'parent page pe jao'],
    reply: 'Went up to the parent page.',
  },
  {
    id: 'notion.inbox', app: NOTION, status: 'held', opens: true,
    title: 'Open the Notion inbox',
    description: 'Open the Notion inbox ("open my notion inbox").',
    params: {},
    steps: [{ op: 'open_url', template: 'notion://www.notion.so/nativetab/updates' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', cues: ['inbox', 'notifications', 'updates', 'any updates'],
    reply: 'Opened your Notion inbox.',
  },
  {
    id: 'notion.home', app: NOTION, status: 'held', opens: true,
    title: 'Open Notion Home',
    description: 'Open Notion Home ("go to notion home").',
    params: {},
    steps: [{ op: 'open_url', template: 'notion://www.notion.so/home' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', cues: ['home', 'go to notion home', 'take me home in', 'ka home kholo', 'show me notion home'],
    reply: 'Opened Home in Notion.',
  },
  {
    id: 'notion.ai', app: NOTION, status: 'held', opens: true,
    title: 'Open Notion AI',
    description: 'Open Notion AI ("open notion ai").',
    params: {},
    steps: [{ op: 'open_url', template: 'notion://www.notion.so/nativetab/assistant' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', cues: ['ai', 'assistant', 'ask notion ai', 'ai chat', 's assistant'],
    reply: 'Opened Notion AI.',
  },
  {
    id: 'notion.trash', app: NOTION, status: 'held', opens: true,
    title: 'Open the Notion trash',
    description: 'Open the Notion trash ("open notion trash").',
    params: {},
    steps: [{ op: 'open_url', template: 'notion://www.notion.so/nativetab/trash' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', cues: ['trash', 'deleted'],
    reply: 'Opened the trash in Notion.',
  },
  {
    id: 'notion.templates', app: NOTION, status: 'held', opens: true,
    title: 'Open Notion templates',
    description: 'Open Notion templates ("open notion templates").',
    params: {},
    steps: [{ op: 'open_url', template: 'notion://www.notion.so/nativetab/templates' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', cues: ['template', 'templates', 'browse notion templates', 'i need a template', 'templates dikhao'],
    reply: 'Opened templates in Notion.',
  },
  {
    id: 'notion.new_page', app: NOTION, status: 'held', opens: true,
    title: 'New Notion page',
    description: 'Start a new Notion page ("new page in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+n' }],
    tier: 'reversible', cues: ['nayi', 'banao', 'new page', 'new notion page', 'new doc', 'new notion doc', 'create a page', 'create a notion page', 'make a doc', 'nayi page banao', 'page banao'],
    reply: 'Started a new page in Notion.',
  },
  {
    id: 'notion.new_page_in_new_tab', app: NOTION, status: 'held', opens: true,
    title: 'New Notion page in a new tab',
    description: 'Start a new Notion page in a new tab ("new notion page in a new tab").',
    params: {},
    steps: [{ op: 'open_url', template: 'notion://www.notion.so/new?deepLinkOpenNewTab=true' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', cues: ['another', 'page in another tab'],
    reply: 'Started a new page in a new Notion tab.',
  },
  {
    id: 'notion.new_page_titled', app: NOTION, status: 'held', opens: true,
    title: 'New Notion page with a title',
    description: 'Start a Notion page with a title ("new notion page called q3 plan").',
    params: { title: { kind: 'literal', description: 'The page title, their exact words', cut: ['called', 'quoted'] } },
    steps: [{ op: 'activate' }, { op: 'focus_mark' }, { op: 'key', chord: 'cmd+n' }, { op: 'focus_moved', timeoutMs: 1500, labelIn: ['new page', 'untitled'] }, { op: 'type', param: 'title' }],
    tier: 'reversible', cues: ['banao', 'new page', 'new notion page', 'create a page', 'make a page', 'start a page', 'start a notion page', 'start a notion page titled', 'naam ki page banao'],
    reply: 'Started a page called {title} in Notion.',
  },
  {
    id: 'notion.new_tab', app: NOTION, status: 'held', opens: true,
    title: 'Open a new Notion tab',
    description: 'Open a new Notion tab ("new tab in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+t' }],
    tier: 'reversible', cues: ['naya', 'another', 'new tab', 'new notion tab', 'another tab', 'naya tab'],
    reply: 'Opened a new tab in Notion.',
  },
  // A close is a destructive menu word to the lint, so it waits for the yes (Notion saves as it goes, and Reopen brings the tab back).
  {
    id: 'notion.close_tab', app: NOTION, status: 'held',
    title: 'Close the Notion tab',
    description: 'Close the Notion tab ("close this notion tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'menu', path: ['File', 'Close Tab'] }],
    tier: 'irreversible', cues: ['close this notion tab', 'close the tab', 'shut this tab', 'close tab', 'yeh tab band'],
    reply: 'Close this tab in Notion?',
  },
  {
    id: 'notion.reopen_tab', app: NOTION, status: 'held', opens: true,
    title: 'Reopen the last closed Notion tab',
    description: 'Reopen the last closed Notion tab ("reopen the tab I closed in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+shift+t' }],
    tier: 'reversible', cues: ['reopen', 'restore', 'closed', 'wapas', 'tab i closed', 'back the closed tab', 'restore that notion tab', 'closed tab', 'woh tab wapas', 'oops reopen it'],
    reply: 'Reopened the last closed tab in Notion.',
  },
  {
    id: 'notion.next_tab', app: NOTION, status: 'held', opens: true,
    title: 'Next Notion tab',
    description: 'Next Notion tab ("next tab in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'ctrl+tab' }],
    tier: 'reversible', cues: ['next', 'right', 'agla', 'next tab', 'tab on the right', 'next notion tab', 'agla tab'],
    reply: 'Next tab.',
  },
  {
    id: 'notion.previous_tab', app: NOTION, status: 'held', opens: true,
    title: 'Previous Notion tab',
    description: 'Previous Notion tab ("previous tab in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'ctrl+shift+tab' }],
    tier: 'reversible', cues: ['previous', 'prev', 'left', 'pichla', 'previous tab', 'tab on the left', 'pichla tab', 'prev tab'],
    reply: 'Previous tab.',
  },
  {
    id: 'notion.tab_1', app: NOTION, status: 'held', opens: true,
    title: 'Go to the first Notion tab',
    description: 'Go to the first Notion tab ("first tab please").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+1' }],
    tier: 'reversible', cues: ['tab', 'first', 'one'],
    reply: 'Went to the first tab in Notion.',
  },
  {
    id: 'notion.tab_2', app: NOTION, status: 'held', opens: true,
    title: 'Go to the second Notion tab',
    description: 'Go to the second Notion tab ("go to the second tab in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+2' }],
    tier: 'reversible', cues: ['tab', 'second', 'two', 'doosra tab'],
    reply: 'Went to the second tab in Notion.',
  },
  {
    id: 'notion.tab_3', app: NOTION, status: 'held', opens: true,
    title: 'Go to the third Notion tab',
    description: 'Go to the third Notion tab ("third notion tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+3' }],
    tier: 'reversible', cues: ['tab', 'third', 'three'],
    reply: 'Went to the third tab in Notion.',
  },
  {
    id: 'notion.tab_4', app: NOTION, status: 'held', opens: true,
    title: 'Go to the fourth Notion tab',
    description: 'Go to the fourth Notion tab ("switch to tab 4 in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+4' }],
    tier: 'reversible', cues: ['tab', 'fourth', 'four', 'tab 4'],
    reply: 'Went to the fourth tab in Notion.',
  },
  {
    id: 'notion.tab_5', app: NOTION, status: 'held', opens: true,
    title: 'Go to the fifth Notion tab',
    description: 'Go to the fifth Notion tab ("jump to tab number five in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+5' }],
    tier: 'reversible', cues: ['tab', 'fifth', 'five', 'tab number'],
    reply: 'Went to the fifth tab in Notion.',
  },
  {
    id: 'notion.tab_6', app: NOTION, status: 'held', opens: true,
    title: 'Go to the sixth Notion tab',
    description: 'Go to the sixth Notion tab ("go to the sixth tab in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+6' }],
    tier: 'reversible', cues: ['tab', 'sixth', 'six'],
    reply: 'Went to the sixth tab in Notion.',
  },
  {
    id: 'notion.tab_7', app: NOTION, status: 'held', opens: true,
    title: 'Go to the seventh Notion tab',
    description: 'Go to the seventh Notion tab ("go to the seventh tab in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+7' }],
    tier: 'reversible', cues: ['tab', 'seventh', 'seven'],
    reply: 'Went to the seventh tab in Notion.',
  },
  {
    id: 'notion.tab_8', app: NOTION, status: 'held', opens: true,
    title: 'Go to the eighth Notion tab',
    description: 'Go to the eighth Notion tab ("go to the eighth tab in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+8' }],
    tier: 'reversible', cues: ['tab', 'eighth', 'eight'],
    reply: 'Went to the eighth tab in Notion.',
  },
  {
    id: 'notion.switch_tab', app: NOTION, status: 'held', opens: true,
    title: 'Switch to a Notion tab by its page title',
    description: 'Switch to a Notion tab by its page title ("switch to the roadmap tab in notion").',
    params: { title: { kind: 'span', description: "Words from the tab's page title" } },
    steps: [{ op: 'activate' }, { op: 'cycle_to_title', param: 'title', chord: 'ctrl+tab', max: 12 }],
    tier: 'reversible', verify: 'title', cues: ['tab', 'switch'],
    reply: 'Switched to {label} in Notion.',
  },
  {
    id: 'notion.new_window', app: NOTION, status: 'held', opens: true,
    title: 'Open a new Notion window',
    description: 'Open a new Notion window ("new notion window").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+shift+n' }],
    tier: 'reversible', cues: ['nayi', 'another', 'second', 'new window', 'new notion window', 'another window', 'another notion window', 'second window', 'nayi window'],
    reply: 'Opened a new Notion window.',
  },
  {
    id: 'notion.toggle_sidebar', app: NOTION, status: 'held',
    title: 'Toggle the Notion sidebar',
    description: 'Show or hide the Notion sidebar ("hide the sidebar in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+\\' }],
    tier: 'reversible', cues: ['sidebar', 'hide the sidebar', 'toggle the sidebar', 'collapse the sidebar', 'sidebar band'],
    reply: 'Toggled the sidebar in Notion.',
  },
  {
    id: 'notion.dark_mode', app: NOTION, status: 'held',
    title: 'Toggle Notion between dark and light',
    description: 'Switch Notion between dark and light ("dark mode in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+shift+l' }],
    tier: 'reversible', cues: ['dark', 'light', 'theme', 'dark mode', 'light mode', 'turn on dark mode', 'toggle notion theme'],
    reply: "Switched Notion's theme.",
  },
  {
    id: 'notion.zoom_in', app: NOTION, status: 'held',
    title: 'Zoom in on Notion',
    description: 'Zoom in on Notion ("zoom in on notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+=' }],
    tier: 'reversible', cues: ['zoom', 'bigger', 'larger', 'bada', 'zoom in on', 'bigger text', 'zoom in'],
    reply: 'Zoomed in.',
  },
  {
    id: 'notion.zoom_out', app: NOTION, status: 'held',
    title: 'Zoom out on Notion',
    description: 'Zoom out on Notion ("zoom out in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+-' }],
    tier: 'reversible', cues: ['zoom', 'smaller', 'shrink', 'chhota', 'zoom out in', 'zoom out'],
    reply: 'Zoomed out.',
  },
  {
    id: 'notion.zoom_reset', app: NOTION, status: 'held',
    title: 'Reset Notion zoom',
    description: 'Reset Notion zoom ("reset zoom in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+0' }],
    tier: 'reversible', cues: ['zoom', 'actual', 'normal', 'reset', 'zoom in', 'actual size', 'back to normal size', 'undo the zoom in', 'normal size', 'the zoom'],
    reply: 'Reset the zoom.',
  },
  {
    id: 'notion.full_screen', app: NOTION, status: 'held',
    title: 'Toggle Notion full screen',
    description: 'Toggle Notion full screen ("full screen notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['View', 'Toggle Full Screen'] }],
    tier: 'reversible', cues: ['full screen', 'fullscreen', 'exit full screen', 'toggle full screen'],
    reply: 'Toggled full screen in Notion.',
  },
  {
    id: 'notion.expand_toggles', app: NOTION, status: 'held',
    title: 'Expand or collapse all Notion toggles',
    description: 'Expand or collapse all Notion toggles ("expand all toggles").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+opt+t' }],
    tier: 'reversible', cues: ['toggle', 'toggles', 'expand', 'collapse', 'expand all', 'collapse all', 'close all toggles', 'saare toggles', 'all the toggle blocks'],
    reply: 'Toggled all the toggles on the page.',
  },
  {
    id: 'notion.copy_link', app: NOTION, status: 'held',
    title: 'Copy the Notion page link',
    description: 'Copy the Notion page link ("copy the link to this page").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+l' }, { op: 'verb', id: 'system.clipboard_read', params: {} }],
    tier: 'reversible', verify: 'echo', cues: ['copy', 'link', 'url', 'link to this page', 'grab the page url', 'copy this page s', 'is page ka link'],
    reply: 'Copied the link to this page.',
  },
  {
    id: 'notion.copy_page_name', app: NOTION, status: 'held',
    title: "Copy the Notion page's name as a link",
    description: 'Copy the Notion page\'s name as a link ("copy the page name").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+opt+l' }],
    tier: 'reversible', cues: ['copy', 'name', 'title', 'page name', 'page name with link', 'grab the page title', 'page ka naam copy'],
    reply: 'Copied the page name as a link.',
  },
  {
    id: 'notion.find_in_page', app: NOTION, status: 'held', opens: true,
    title: 'Find words on the Notion page',
    description: 'Find words on the Notion page ("find pricing on this page").',
    params: { text: { kind: 'literal', description: 'The exact words to find', cut: ['query', 'after_saying'] } },
    steps: [{ op: 'activate' }, { op: 'focus_mark' }, { op: 'key', chord: 'cmd+f' }, { op: 'focus_moved', timeoutMs: 800, labelIn: ['find', 'search'] }, { op: 'type', param: 'text' }],
    tier: 'reversible', cues: ['find', 'page', 'where', 'dhundo', 'search this page'],
    reply: 'Looking for {text} on the page.',
  },
  {
    id: 'notion.settings', app: NOTION, status: 'held', opens: true,
    title: 'Open Notion settings',
    description: 'Open Notion settings ("open notion settings").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+,' }],
    tier: 'reversible', cues: ['settings', 'preferences', 'change my notion settings'],
    reply: 'Opened Notion settings.',
  },
  {
    id: 'notion.reload', app: NOTION, status: 'held',
    title: 'Reload Notion',
    description: 'Reload Notion ("reload notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+r' }],
    tier: 'reversible', cues: ['reload', 'refresh', 'is stuck refresh it', 'reload the page'],
    reply: 'Reloaded Notion.',
  },
  // Printing is outward (the catalog audit leaves prints for the yes); the yes only opens the dialog.
  {
    id: 'notion.print', app: NOTION, status: 'held',
    title: 'Print the Notion page',
    description: 'Print the Notion page ("print this notion page").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'menu', path: ['File', 'Print…'] }],
    tier: 'irreversible', cues: ['print', 'print this notion page', 'print this page', 'print the page'],
    reply: 'Open the print window for this page in Notion?',
  },  // ── R3c: the catalog rulings' accepts ─────────────────────────────────────────────────────────
  // History through the menu bar: a menu press never reaches the editor, where cmd+[ and cmd+] may outdent and indent.
  {
    id: 'notion.back', app: NOTION, status: 'held', opens: true,
    title: 'Go back in Notion',
    description: 'Go back in Notion ("go back in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['History', 'Back'] }],
    tier: 'reversible', cues: ['back', 'previous', 'peeche', 'back a page', 'previous page', 'back one page', 'peeche jao'],
    reply: 'Went back in Notion.',
  },
  {
    id: 'notion.forward', app: NOTION, status: 'held', opens: true,
    title: 'Go forward in Notion',
    description: 'Go forward in Notion ("go forward in notion").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['History', 'Forward'] }],
    tier: 'reversible', cues: ['forward', 'aage', 'forward a page', 'forward one page', 'forward again', 'aage jao'],
    reply: 'Went forward in Notion.',
  },
  // The comment box on the selected block only: nothing posts until they type and post it.
  {
    id: 'notion.comment', app: NOTION, status: 'held', opens: true,
    title: 'Open a Notion comment box',
    description: 'Open a comment box on the selected block in Notion ("comment on this").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+shift+m' }],
    tier: 'reversible', cues: ['comment', 'comments', 'add a comment', 'comment on this', 'leave a comment here', 'yahan comment daalo'],
    reply: 'The comment box is open. Type your comment and post it when ready.',
  },
];
